import React from 'react';
import ReactDOM from 'react-dom/client';
import Recommendations from './widgets/Recommendations';

const recommendations = document.querySelectorAll(
    '.constructor-recommendations'
);

import './i18n';

recommendations.forEach((recommendationsDiv) => {
    const attributes = {
        podId: recommendationsDiv.getAttribute('data-podId'),
        itemId: recommendationsDiv.getAttribute('data-itemId'),
        count: parseInt(recommendationsDiv.getAttribute('data-count')),
        isSlider: recommendationsDiv.getAttribute('data-slider')?.length > 0,
        isAutoplay: recommendationsDiv.getAttribute('data-slider-autoplay'),
        autoplaySpeed: recommendationsDiv.getAttribute('data-autoplay-speed'),
        isVertical: recommendationsDiv.getAttribute('vertical')?.length > 0,
        marketData: recommendationsDiv.getAttribute('data-market'),
        wishlistData: recommendationsDiv.getAttribute('data-wishlists'),
        discountData: recommendationsDiv.getAttribute('data-discount'),
        headingType: recommendationsDiv.getAttribute('data-heading-type'),
        showOnNoResults: recommendationsDiv.getAttribute(
            'data-show-on-no-results'
        )
    };

    ReactDOM.createRoot(recommendationsDiv).render(
        <Recommendations {...attributes} />
    );
});
